(function ($) {
	"use strict";



	// Hero Header carousel
	$(".header-carousel").owlCarousel({
		animateOut: 'fadeOut',
		items: 1,
		margin: 0,
		stagePadding: 0,
		autoplay: true,
		smartSpeed: 500,
		dots: true,
		loop: true,
		nav : true,
		navText : [
			'<i class="bi bi-arrow-left"></i>',
			'<i class="bi bi-arrow-right"></i>'
		],
	});




})(jQuery);

